import { useQuery } from "@/api/swr/useQuery";
import { certificationSchema } from "@/schema/console/certifications/Certification";

type Config = Parameters<typeof useQuery<typeof certificationSchema>>[2];

export function useGetCertification(id: string, config?: Config) {
  return useQuery(certificationSchema, `/console/certifications/${id}`, config);
}
